/**
 * Owner: Masa Bayu
 * File: batch01-fixtures.ts
 * Date:Time: 2026-09-19 19:59
 * Description: Batch 1 certification fixtures — arabic · hebrew (RTL).
 */
import {} from './batch01-codes';
function fixturesFor(familyId, scriptLabel, dirLabel) {
    return Object.freeze([
        Object.freeze({
            id: `fixture:${familyId}/identity`,
            familyId,
            area: 'identity',
            description: `canonical languageId samples for ${familyId}`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/script`,
            familyId,
            area: 'script',
            description: `${scriptLabel} script identity`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/direction-rtl`,
            familyId,
            area: 'direction',
            description: `${dirLabel} default + explicit rtl override`,
        }),
        Object.freeze({
            id: `fixture:${familyId}/content-multilingual`,
            familyId,
            area: 'content',
            description: 'primary + contentLanguages + inline override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxw-author-preserve`,
            familyId,
            area: 'qxw',
            description: 'QXW root metadata author → preserve',
        }),
        Object.freeze({
            id: `fixture:${familyId}/qxp-publish-preserve`,
            familyId,
            area: 'qxp',
            description: 'QXP artifact preserve-through-publish',
        }),
        Object.freeze({
            id: `fixture:${familyId}/reader-render-contract`,
            familyId,
            area: 'reader',
            description: 'script typography stacks (render contract)',
        }),
        Object.freeze({
            id: `fixture:${familyId}/search-normalize`,
            familyId,
            area: 'search',
            description: 'NFC normalize + script-aware analyzer prep',
        }),
        Object.freeze({
            id: `fixture:${familyId}/navigation-structure`,
            familyId,
            area: 'navigation',
            description: 'writing mode + heading role metadata',
        }),
        Object.freeze({
            id: `fixture:${familyId}/annotation-anchors`,
            familyId,
            area: 'annotation',
            description: 'original text preserved for anchors',
        }),
        Object.freeze({
            id: `fixture:${familyId}/a11y-lang-semantics`,
            familyId,
            area: 'accessibility',
            description: 'content lang + RTL reading order for AT',
        }),
        Object.freeze({
            id: `fixture:${familyId}/serialize-roundtrip`,
            familyId,
            area: 'serialization',
            description: 'metadata / content round-trip',
        }),
        Object.freeze({
            id: `fixture:${familyId}/regression-suite`,
            familyId,
            area: 'regression',
            description: 'content id stable under override',
        }),
        Object.freeze({
            id: `fixture:${familyId}/provenance-chain`,
            familyId,
            area: 'provenance',
            description: 'source → evidence area trace',
        }),
    ]);
}
export const QX_BATCH_01_ARABIC_FIXTURES = fixturesFor('arabic', 'Arab', 'RTL');
export const QX_BATCH_01_HEBREW_FIXTURES = fixturesFor('hebrew', 'Hebr', 'RTL');
export const QX_BATCH_01_FIXTURES = Object.freeze([
    ...QX_BATCH_01_ARABIC_FIXTURES,
    ...QX_BATCH_01_HEBREW_FIXTURES,
]);
export const QX_BATCH_01_ARABIC_SAMPLE_LANGUAGES = Object.freeze([
    'ar',
    'fa',
    'ur',
]);
export const QX_BATCH_01_HEBREW_SAMPLE_LANGUAGES = Object.freeze([
    'he',
    'yi',
]);
export const QX_BATCH_01_TEXT_SAMPLES = Object.freeze({
    ar: 'مرحبا بالعالم — عينة اعتماد العربية.',
    fa: 'سلام دنیا — نمونه گواهی عربی‌خط.',
    he: 'שלום עולם — מדגם הסמכת עברית.',
    yi: 'העלאָ וועלט — העברעאישע סערטיפיקאַציע.',
    composed: 'cafe\u0301',
});
export function listBatch01FixtureIds(familyId) {
    const list = familyId === 'arabic'
        ? QX_BATCH_01_ARABIC_FIXTURES
        : familyId === 'hebrew'
            ? QX_BATCH_01_HEBREW_FIXTURES
            : QX_BATCH_01_FIXTURES;
    return Object.freeze(list.map((f) => f.id));
}
export function fixturesForBatch01Family(familyId) {
    return familyId === 'arabic'
        ? QX_BATCH_01_ARABIC_FIXTURES
        : QX_BATCH_01_HEBREW_FIXTURES;
}
//# sourceMappingURL=batch01-fixtures.js.map